import { ScoreFactor } from "@inrange/building-manager-api-client/models-site";

export const STATUS_SYMBOL: Record<ScoreFactor["status"], string> = {
  positive: "+",
  negative: "-",
  neutral: "·",
  skipped: "—",
};

export const STATUS_COLOR: Record<ScoreFactor["status"], string> = {
  positive: "#01B28A",
  negative: "#AD7A2D",
  neutral: "#666666",
  skipped: "#999999",
};
